
// If REACT_APP_API_BASE_URL is explicitly set (even to empty string), use it
// Otherwise default to http://localhost:8080 for local development
const API_BASE = process.env.REACT_APP_API_BASE_URL !== undefined
  ? process.env.REACT_APP_API_BASE_URL
  : 'http://localhost:8080';

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE}/api/auth/login`,
  LOGOUT: `${API_BASE}/api/auth/logout`,
  ME: `${API_BASE}/api/auth/me`,
  ME_DETAILS: `${API_BASE}/api/users/details`,
  REGISTER: `${API_BASE}/api/auth/register`,
  BOOK: `${API_BASE}/api/book`,
  GET_BOOK: (id) => `${API_BASE}/api/book/${id}`,
  SEARCH_BOOKS: `${API_BASE}/api/book/search`,
  RESERVATION: `${API_BASE}/api/reservation`,
  PASSWORD_CHANGE_REQUEST: `${API_BASE}/api/reset/requestPasswordReset`,
  PASSWORD_RESET: `${API_BASE}/api/reset/resetPassword`,
  HISTORY: `${API_BASE}/api/borrowing/me/history`,
  HISTORY_ID: `${API_BASE}/api/borrowing/user/history`,
  USERS: `${API_BASE}/api/users`,
  USERS_SEARCH: `${API_BASE}/api/users/search`,
  USER_DETAILS: `${API_BASE}/api/users/details`,
  MESSAGES: `${API_BASE}/api/messages`,
  MESSAGES_UNREAD: `${API_BASE}/api/messages/unread`,
  MESSAGES_SET_READ: (id) => `${API_BASE}/api/messages/${id}/read`,
  AUTHOR: `${API_BASE}/api/author`,
  ILLUSTRATOR: `${API_BASE}/api/illustrator`,
  PUBLISHER: `${API_BASE}/api/publisher`,
  EMPLOYEE: `${API_BASE}/api/employee`,
  BORROWING: `${API_BASE}/api/borrowing`,
  BORROWING_RETURN: `${API_BASE}/api/borrowing/return`,
  SCHEDULE: `${API_BASE}/api/schedule`,
  SCHEDULE_MY: `${API_BASE}/api/schedule/my`,
  LOOKUP_ROLES: `${API_BASE}/api/lookup/roles`,
  LOOKUP_JOB_POSITIONS: `${API_BASE}/api/lookup/job-positions`,
  LOOKUP_DEPARTMENTS: `${API_BASE}/api/lookup/departments`,
  LOOKUP_EMPLOYMENT_STATUSES: `${API_BASE}/api/lookup/employment-statuses`,
  APP_SETTINGS: `${API_BASE}/api/settings`,
  DASHBOARD_STATS: `${API_BASE}/api/dashboard/stats`,
  BORROWING_ALL_ACTIVE: `${API_BASE}/api/borrowing/all/active`,
  BORROWING_ALL_RETURNED: `${API_BASE}/api/borrowing/all/returned`,
  BORROWING_ALL_RESERVATIONS: `${API_BASE}/api/borrowing/all/reservations`,
  BORROWING_ALL_OVERDUE: `${API_BASE}/api/borrowing/all/overdue`,
  GENRE: `${API_BASE}/api/genre`,
  BOOK_SIMILAR: (id) => `${API_BASE}/api/book/${id}/similar`,
  BOOK_RECOMMENDATIONS: `${API_BASE}/api/book/recommendations`,
  BOOK_REVIEWS: (id) => `${API_BASE}/api/reviews/book/${id}`,
  BOOK_REVIEWS_SUMMARY: (id) => `${API_BASE}/api/reviews/book/${id}/summary`,
};

export const ROLES = {
  USER: 'ROLE_USER',
  ADMIN: 'ROLE_ADMIN',
  EMPLOYEE: 'ROLE_EMPLOYEE'
}